import React, { useEffect, useRef, useState, useMemo } from "react";
import { Button } from "react-bootstrap";
import Loader from "../../../Loader/Loader";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import RadarMain from "./YieldRaddarComp/Radar";
import {
  bindDailyFromRecommendedRates,
  bindDailyFromRateShop,
  bindDailyFromEvents,
  bindDailyFromChannelStly,
  formatEventsList,
  toCalendarYMD,
} from "./YieldRaddarComp/yieldRadarData";
import DatePicker from "react-datepicker";
import CustomRangePicker from "../../../CommonComponent/CustomRangePIcker";

export const YieldRadar = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const { propertyCode, snapshotId } = useParams();
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty.defaultAsOfDate,
  );
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail,
  );
  const crmPropertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.crmPropertyDetail,
  );

  const getYMDLocalDate = (rawVal) => {
    const ymd = toCalendarYMD(rawVal);
    if (!ymd) return new Date();
    const parts = ymd.split("-").map(Number);
    if (parts.length === 3 && !isNaN(parts[0]) && !isNaN(parts[1]) && !isNaN(parts[2])) {
      return new Date(parts[0], parts[1] - 1, parts[2], 12, 0, 0);
    }
    return new Date();
  };

  const mainAsOfDate =
    para?.asOfDate || defaultAsOfDateFromRTK || moment().format("YYYY-MM-DD");
  const baseDate = getYMDLocalDate(mainAsOfDate);

  const [startDate, setStartDate] = useState(
    () => new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), 12, 0, 0),
  );
  const [endDate, setEndDate] = useState(
    () => new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate() + 30, 12, 0, 0),
  );
  const [startRangeDate, setStartRangeDate] = useState(
    () => new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), 12, 0, 0),
  );
  const [endRangeDate, setEndRangeDate] = useState(
    () => new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate() + 30, 12, 0, 0),
  );
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [activePresetRange, setActivePresetRange] = useState(null);

  const prevAsOfDateRef = useRef(mainAsOfDate);
  const isFirstMountRef = useRef(true);

  const [loading, setLoading] = useState(api !== 0);
  const [dailyData, setDailyData] = useState([]);
  const [reservationData, setReservationData] = useState([]);
  const [reservationsLoading, setReservationsLoading] = useState(false);
  const [eventsList, setEventsList] = useState([]);
  const fetchIdRef = useRef(0);

  const capacity =
    Number(propertyDetailFromRTK?.revenuconfig?.[0]?.totalrooms) || 126;

  const previewSampleDaily = useMemo(() => {
    if (api !== 0) return [];
    const baseStr = toCalendarYMD(mainAsOfDate) || moment().format("YYYY-MM-DD");
    const today = moment(baseStr, "YYYY-MM-DD");
    return [0, 1, 2, 3, 4].map((offset) => {
      const d = today.clone().add(offset, "days").format("YYYY-MM-DD");
      return {
        stay_date: d,
        event: offset === 0 ? "Sample Event" : "",
        otb_rooms: 60 + offset * 5,
        otb_rev: (60 + offset * 5) * 125,
        stly_otb_rooms: 55 + offset * 4,
        stly_otb_rev: (55 + offset * 4) * 120,
        forecast_rooms: 75 + offset * 5,
        bar: 130 + offset * 5,
        brand_ty: 30,
        brand_ly: 25,
        booking_ty: 15,
        booking_ly: 12,
        expedia_ty: 20,
        expedia_ly: 18,
      };
    });
  }, [api, mainAsOfDate]);

  const [tblids] = useState(() => ({
    id1: commonService.GenerateGUID(),
    rankTableId: commonService.GenerateGUID(),
    resTableId: commonService.GenerateGUID(),
  }));

  const widgetDetailRef = useRef();

  const [widgetModal, setWidgetModal] = useState(false);

  const closeWidgetModal = () => {
    setWidgetModal(false);
  };

  const handleDateChange = (dates) => {
    if (api === 0) return;
    const [start, end] = dates;
    setStartRangeDate(start);
    setEndRangeDate(end);
    setActivePresetRange(null);
  };

  const handlePresetChange = (start, end, type) => {
    if (api === 0) return;
    setStartRangeDate(start);
    setEndRangeDate(end);
    setStartDate(start);
    setEndDate(end);
    GetWidgetData(start, end);
  };

  const handleApply = (e) => {
    e.stopPropagation();
    if (api === 0) return;
    if (startRangeDate && endRangeDate) {
      setStartDate(startRangeDate);
      setEndDate(endRangeDate);
      setOpenDatePicker(false);
      GetWidgetData(startRangeDate, endRangeDate);
    }
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    if (api === 0) return;
    setStartRangeDate(startDate);
    setEndRangeDate(endDate);
    setOpenDatePicker(false);
    setActivePresetRange(null);
  };

  const handleReset = () => {
    if (api === 0) return;
    const mDate = getYMDLocalDate(mainAsOfDate);
    const defaultStart = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate(), 12, 0, 0);
    const defaultEnd = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() + 30, 12, 0, 0);
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setStartRangeDate(defaultStart);
    setEndRangeDate(defaultEnd);
    setActivePresetRange(null);
    GetWidgetData(defaultStart, defaultEnd);
  };

  const GetWidgetData = async (
    customStart = startDate,
    customEnd = endDate,
  ) => {
    if (api === 0) return;
    const currentFetchId = ++fetchIdRef.current;
    try {
      setLoading(true);
      setReservationsLoading(true);

      const activeAsOfDate = mainAsOfDate;
      const compareDateFormatted = moment(toCalendarYMD(activeAsOfDate), "YYYY-MM-DD")
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      const propCode =
        propertyDetailFromRTK?.propertycode ||
        para?.propertyCode ||
        propertyCode ||
        "";
      const propId = propertyDetailFromRTK?.propertyid || para?.propertyId || 0;

      let latestRecommendedRates = null;
      let latestRateShopList = null;
      let latestEventList = null;
      let latestChannelStlyList = null;

      const mergeAndSetDaily = () => {
        if (fetchIdRef.current !== currentFetchId) return;
        let currentDaily = [];
        if (latestRecommendedRates && latestRecommendedRates.length > 0) {
          currentDaily = bindDailyFromRecommendedRates(latestRecommendedRates, []);
        }
        if (latestRateShopList && latestRateShopList.length > 0) {
          currentDaily = bindDailyFromRateShop(latestRateShopList, currentDaily);
        }
        if (latestEventList && latestEventList.length > 0) {
          currentDaily = bindDailyFromEvents(latestEventList, currentDaily);
        }
        if (latestChannelStlyList && latestChannelStlyList.length > 0) {
          currentDaily = bindDailyFromChannelStly(latestChannelStlyList, currentDaily);
        }
        setDailyData(currentDaily);
      };

      // 1. Kick off non-blocking background fetches concurrently
      (async () => {
        try {
          const byPropertyIdResponse = await apiCall(
            {
              method: "POST",
              url:
                API_URL.BASE_API_URL.RevenueManagement +
                API_URL.REVENUE_RATE_SHOP_CONFIG.GET_BY_PROPERTY_ID,
              body: { id: propId },
            },
            false,
          );

          const propertyResponse = apiResponse(false, byPropertyIdResponse);
          const channelTerm =
            propertyResponse?.data?.data?.channel_term ||
            propertyResponse?.data?.channel_term ||
            byPropertyIdResponse?.data?.channel_term ||
            byPropertyIdResponse?.channel_term ||
            "";

          const rateShopDataResponse = await apiCall(
            {
              method: "POST",
              url:
                API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.RATESHOP_LIST,
              body: {
                AsOfDate: activeAsOfDate,
                propertyCode: propCode,
                Channel: channelTerm,
                startDate: commonService.getDateInDBFormat(customStart),
                endDate: commonService.getDateInDBFormat(customEnd),
                propertyid: propId,
                CompareDate: compareDateFormatted,
              },
            },
            false,
          );

          let rateShopList = [];
          const rsResponse = apiResponse(false, rateShopDataResponse);
          if (rsResponse?.isValidate) {
            rateShopList = Array.isArray(rsResponse?.data?.data)
              ? rsResponse.data.data
              : Array.isArray(rsResponse?.data)
                ? rsResponse.data
                : [];
          } else if (Array.isArray(rateShopDataResponse)) {
            rateShopList = rateShopDataResponse;
          } else if (Array.isArray(rateShopDataResponse?.data?.data)) {
            rateShopList = rateShopDataResponse.data.data;
          } else if (Array.isArray(rateShopDataResponse?.data)) {
            rateShopList = rateShopDataResponse.data;
          }
          return rateShopList;
        } catch (err) {
          console.error("fetchRateShop error:", err);
          return [];
        }
      })().then((rateShopList) => {
        if (fetchIdRef.current !== currentFetchId) return;
        latestRateShopList = rateShopList;
        if (latestRecommendedRates) {
          mergeAndSetDaily();
        }
      });

      (async () => {
        try {
          const eventListResponse = await apiCall(
            {
              method: "POST",
              url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
              body: {
                pageNum: 1,
                pageSize: 100,
                sortColumn: "",
                sortDirection: "asc",
                searchValue: "",
                propertyid: crmPropertyDetailFromRTK?.propertyid || propId,
                startdate: commonService.getDateInDBFormat(customStart),
                enddate: commonService.getDateInDBFormat(customEnd),
                eventname: "",
                eventtypeterm: "",
                yearterm: "",
              },
            },
            false,
          );

          let eventList = [];
          const evResponse = apiResponse(false, eventListResponse);
          if (evResponse?.isValidate) {
            eventList = Array.isArray(evResponse?.data?.data)
              ? evResponse.data.data
              : Array.isArray(evResponse?.data)
                ? evResponse.data
                : [];
          } else if (Array.isArray(eventListResponse)) {
            eventList = eventListResponse;
          } else if (Array.isArray(eventListResponse?.data?.data)) {
            eventList = eventListResponse.data.data;
          } else if (Array.isArray(eventListResponse?.data)) {
            eventList = eventListResponse.data;
          }
          return eventList;
        } catch (err) {
          console.error("fetchEvents error:", err);
          return [];
        }
      })().then((eventList) => {
        if (fetchIdRef.current !== currentFetchId) return;
        latestEventList = eventList;
        const formatted = formatEventsList(eventList);
        setEventsList(formatted);
        if (latestRecommendedRates) {
          mergeAndSetDaily();
        }
      });

      (async () => {
        const extractResList = (raw) => {
          if (!raw) return [];
          const response = apiResponse(false, raw);
          if (response?.isValidate) {
            return Array.isArray(response?.data?.data)
              ? response.data.data
              : Array.isArray(response?.data)
                ? response.data
                : Array.isArray(raw?.data?.data)
                  ? raw.data.data
                  : Array.isArray(raw?.data)
                    ? raw.data
                    : Array.isArray(raw)
                      ? raw
                      : [];
          } else if (Array.isArray(raw)) {
            return raw;
          } else if (Array.isArray(raw?.data?.data)) {
            return raw.data.data;
          } else if (Array.isArray(raw?.data)) {
            return raw.data;
          }
          return [];
        };

        const startDateDB = commonService.getDateInDBFormat(customStart);
        const endDateDB = commonService.getDateInDBFormat(customEnd);

        const stlyStartDB = moment(toCalendarYMD(customStart), "YYYY-MM-DD")
          .subtract(364, "days")
          .format("YYYY-MM-DD");
        const stlyEndDB = moment(toCalendarYMD(customEnd), "YYYY-MM-DD")
          .subtract(364, "days")
          .format("YYYY-MM-DD");

        const asOfValue = para?.asOfDate || activeAsOfDate;
        const propCodeValue = para?.propertyCode || propCode;

        try {
          const [radarReservationData, radarReservationDataSTLY] =
            await Promise.all([
              apiCall(
                {
                  method: "POST",
                  url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.YIELD_RADAR.RESERVATION_DATA,
                  body: {
                    AsOfDate: asOfValue,
                    startDate: startDateDB,
                    endDate: endDateDB,
                    propertycode: propCodeValue,
                  },
                },
                false,
              ).catch((err) => {
                console.error("fetchReservations callCurrent error:", err);
                return [];
              }),
              apiCall(
                {
                  method: "POST",
                  url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.YIELD_RADAR.RESERVATION_DATA,
                  body: {
                    AsOfDate: asOfValue,
                    startDate: stlyStartDB,
                    endDate: stlyEndDB,
                    propertycode: propCodeValue,
                  },
                },
                false,
              ).catch((err) => {
                console.error("fetchReservations callSTLY error:", err);
                return [];
              }),
            ]);

          const listCurrent = extractResList(radarReservationData);
          const listSTLY = extractResList(radarReservationDataSTLY);

          const taggedCurrent = listCurrent.map((r) => ({
            ...r,
            is_stly: false,
            isStly: false,
          }));

          const taggedSTLY = listSTLY.map((r) => {
            const rawArr = r.arrival_date || r.arrival;
            const rawDep = r.departure_date || r.depart;
            const alignedArr = rawArr
              ? moment(toCalendarYMD(rawArr), "YYYY-MM-DD")
                  .add(364, "days")
                  .format("YYYY-MM-DD")
              : "";
            const alignedDep = rawDep
              ? moment(toCalendarYMD(rawDep), "YYYY-MM-DD")
                  .add(364, "days")
                  .format("YYYY-MM-DD")
              : "";
            return {
              ...r,
              is_stly: true,
              isStly: true,
              aligned_arrival_date: alignedArr,
              aligned_departure_date: alignedDep,
            };
          });

          return [...taggedCurrent, ...taggedSTLY];
        } catch (err) {
          console.error("fetchReservations error:", err);
          return [];
        }
      })().then((resList) => {
        if (fetchIdRef.current !== currentFetchId) return;
        setReservationData(resList || []);
        setReservationsLoading(false);
      });

      // Background channel STLY call (non-blocking)
      (async () => {
        try {
          const dbdStlyResponse = await apiCall(
            {
              method: "POST",
              url:
                API_URL.BASE_API_URL.SnapShot + API_URL.MARKET_SEGMENT.CHANNEL_STLY,
              body: {
                AsOfDate: para?.asOfDate || activeAsOfDate,
                startDate: commonService.getDateInDBFormat(customStart),
                endDate: commonService.getDateInDBFormat(customEnd),
                propertyCode: para?.propertyCode || propCode,
              },
            },
            false,
          );

          let channelStlyList = [];
          const response = apiResponse(false, dbdStlyResponse);
          if (response?.isValidate) {
            channelStlyList = Array.isArray(response?.data?.data)
              ? response.data.data
              : Array.isArray(response?.data)
                ? response.data
                : [];
          } else if (Array.isArray(dbdStlyResponse)) {
            channelStlyList = dbdStlyResponse;
          } else if (Array.isArray(dbdStlyResponse?.data?.data)) {
            channelStlyList = dbdStlyResponse.data.data;
          } else if (Array.isArray(dbdStlyResponse?.data)) {
            channelStlyList = dbdStlyResponse.data;
          }
          return channelStlyList;
        } catch (err) {
          console.error("fetchChannelStly error:", err);
          return [];
        }
      })().then((channelStlyList) => {
        if (fetchIdRef.current !== currentFetchId) return;
        latestChannelStlyList = channelStlyList;
        if (latestRecommendedRates) {
          mergeAndSetDaily();
        }
      });

      // 2. Fetch the primary data needed for the UI (Recommended Rates)
      const resData = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.SnapShot +
            API_URL.DAILY_SUMMARY.RECOMMENDED_RATE,
          body: {
            asofdate: activeAsOfDate,
            startdate: commonService.getDateInDBFormat(customStart),
            enddate: commonService.getDateInDBFormat(customEnd),
            propertycode: propCode,
          },
        },
        false,
      );

      let rateList = [];
      if (Array.isArray(resData)) {
        rateList = resData;
      } else if (Array.isArray(resData?.data?.data)) {
        rateList = resData.data.data;
      } else if (Array.isArray(resData?.data)) {
        rateList = resData.data;
      } else {
        const response = apiResponse(false, resData);
        if (response?.isValidate) {
          rateList = Array.isArray(response?.data?.data)
            ? response.data.data
            : Array.isArray(response?.data)
              ? response.data
              : [];
        }
      }

      if (fetchIdRef.current !== currentFetchId) return;

      latestRecommendedRates = rateList;
      mergeAndSetDaily();
    } catch (err) {
      console.error("YieldRadar GetWidgetData error:", err);
    } finally {
      if (fetchIdRef.current === currentFetchId) {
        // UI is ready to display! Dismiss the main loading screen immediately!
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (api === 0) return;
    if (isFirstMountRef.current) {
      isFirstMountRef.current = false;
      GetWidgetData(startDate, endDate);
      return;
    }

    if (prevAsOfDateRef.current !== mainAsOfDate) {
      prevAsOfDateRef.current = mainAsOfDate;
      const mDate = getYMDLocalDate(mainAsOfDate);
      const newStart = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate(), 12, 0, 0);
      const newEnd = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() + 30, 12, 0, 0);
      setStartDate(newStart);
      setEndDate(newEnd);
      setStartRangeDate(newStart);
      setEndRangeDate(newEnd);
      setActivePresetRange(null);
      GetWidgetData(newStart, newEnd);
    } else {
      GetWidgetData(startDate, endDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainAsOfDate, propertyDetailFromRTK?.propertyid, propertyDetailFromRTK?.propertycode, para?.propertyCode, propertyCode, api]);

  const activePropertyCode =
    propertyDetailFromRTK?.propertycode ||
    para?.propertyCode ||
    propertyCode;
  const activeAsOfDate = mainAsOfDate;

  if (
    api !== 0 &&
    (!activePropertyCode ||
      !activeAsOfDate ||
      (loading && (!dailyData || dailyData.length === 0)))
  ) {
    return (
      <div
        className="d-flex justify-content-center align-items-center w-100"
        style={{ minHeight: "75vh" }}
      >
        <Loader />
      </div>
    );
  }

  const handleSendMail = (tableId) => {
    if (api === 0) return;
    commonService.fnSendWidgetMail(
      tableId || tblids.id1,
      "Yield Radar",
      snapshotId,
      defaultAsOfDateFromRTK,
      "",
      para?.widgetId,
    );
  };

  const handleInfo = () => {
    if (api === 0) return;
    widgetDetailRef.current = {
      widgetdetails: "",
      usernote: "",
      compName: compName?.YieldRadar,
      widgetId: para?.widgetId,
    };
    setWidgetModal(true);
  };

  return (
    <div
      className={`widget-container yieldradar-widget-main snapshotrow ${api === 0 ? "yieldradar-disabled" : ""}`}
      style={{
        position: "relative",
        padding: "0 5px",
        ...(api === 0 ? { pointerEvents: "none", userSelect: "none" } : {}),
      }}
      rowtitle="Yield Radar"
    >
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          <Button className="heading-menu-btns" type="button" title="Send Mail">
            <img
              id={commonService.generateGlobalClickTrackerID(
                "YieldRadar",
                "emailicon",
                activePropertyCode,
              )}
              src={emailIcon}
              alt="emailIcon"
              onClick={() => {
                handleSendMail(tblids.id1);
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img
              id={commonService.generateGlobalClickTrackerID(
                "YieldRadar",
                "info",
                activePropertyCode,
              )}
              src={infoIcon}
              alt="info"
              onClick={handleInfo}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img
              id={commonService.generateGlobalClickTrackerID(
                "YieldRadar",
                "menuicon",
                activePropertyCode,
              )}
              src={downloadIcon}
              alt="menuIcon"
              import={tblids.id1}
              onClick={() => {
                commonService.fnExportInCSV(
                  tblids.id1,
                  `${activePropertyCode || "Property"}-Yield Radar-${moment(
                    new Date(),
                  ).format("MMDDYYYY")}`,
                );
              }}
            />
          </Button>
        </div>
      )}
      <div className="w-100 position-relative" style={{ minHeight: "500px" }}>
        {loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(255, 255, 255, 0.65)",
              zIndex: 999,
            }}
          >
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pointerEvents: "none",
              }}
            >
              <Loader />
            </div>
          </div>
        )}
        <RadarMain
          propertyCode={activePropertyCode}
          propertyName={propertyDetailFromRTK?.propertyname}
          asOfDate={activeAsOfDate}
          capacity={capacity}
          startDate={commonService.getDateInDBFormat(startDate)}
          endDate={commonService.getDateInDBFormat(endDate)}
          dailyData={api === 0 ? previewSampleDaily : dailyData}
          reservationData={reservationData}
          reservationsLoading={reservationsLoading}
          api={api}
          loading={loading}
          combinedTableId={tblids.id1}
          eventsList={eventsList}
          getEventList={() => {
            if (api === 0) return;
            GetWidgetData(startDate, endDate);
          }}
          headerControls={
            <div className="groupiq-date-controls">
              <div className="groupiq-date-input">
                <DatePicker
                  id={commonService.generateGlobalClickTrackerID(
                    "YieldRadar",
                    "range-date-picker",
                    propertyCode,
                  )}
                  portalId="datepicker-root"
                  className="groupiq-datepicker"
                  onChange={handleDateChange}
                  startDate={startRangeDate}
                  endDate={endRangeDate}
                  selectsRange
                  monthsShown={2}
                  open={api === 0 ? false : openDatePicker}
                  disabled={api === 0}
                  onClickOutside={() => setOpenDatePicker(false)}
                  onInputClick={() => {
                    if (api === 0) return;
                    setOpenDatePicker(true);
                  }}
                  shouldCloseOnSelect={false}
                  placeholderText="MM/DD/YYYY - MM/DD/YYYY"
                >
                  <div className="w-100" style={{ display: "inline-block" }}>
                    <CustomRangePicker
                      id={commonService.generateGlobalClickTrackerID(
                        "YieldRadar",
                        "occ-date-rangepicker",
                        propertyCode,
                      )}
                      activePreset={activePresetRange}
                      setActivePreset={setActivePresetRange}
                      setOpenDatePicker={setOpenDatePicker}
                      onChange={(start, end, type) => {
                        if (api === 0) return;
                        handlePresetChange(start, end, type);
                      }}
                    />
                    <div className="content-inside-calendar">
                      <p>
                        {startRangeDate
                          ? commonService.getDateInFormat(startRangeDate)
                          : ""}
                        {startRangeDate && endRangeDate ? " - " : ""}
                        {endRangeDate
                          ? commonService.getDateInFormat(endRangeDate)
                          : ""}
                      </p>
                      <div className="d-flex align-items-center gap-2">
                        <button
                          id={commonService.generateGlobalClickTrackerID(
                            "YieldRadar",
                            "occ-date-cancel-btn",
                            propertyCode,
                          )}
                          className="secondary-btn"
                          disabled={api === 0}
                          onClick={handleCancel}
                        >
                          Cancel
                        </button>
                        <button
                          id={commonService.generateGlobalClickTrackerID(
                            "YieldRadar",
                            "occ-date-apply-btn",
                            propertyCode,
                          )}
                          className="primary-btn"
                          disabled={api === 0 || !startRangeDate || !endRangeDate}
                          onClick={handleApply}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                </DatePicker>
              </div>
              <Button
                id={commonService.generateGlobalClickTrackerID(
                  "YieldRadar",
                  "reset",
                  propertyCode,
                )}
                className="default-btn primary-btn"
                type="button"
                disabled={api === 0}
                onClick={handleReset}
                style={{
                  height: "30px",
                  padding: "0 18px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "13px",
                  borderRadius: "5px",
                  color: "#ffffff",
                  ...(api === 0 ? { opacity: 0.65, cursor: "not-allowed" } : {}),
                }}
              >
                RESET
              </Button>
            </div>
          }
        />
      </div>
      {api !== 0 && (
        <Comments widgetDetails={para} editorId={"YieldRadar" + tblids.id1} />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default YieldRadar;
